import { User } from '@auth0/auth0-react'
import { create } from 'zustand'
import { Company } from '@/types'

export type UserState = {
  user: User | undefined
  isAdmin: boolean
  isDashboardUser: boolean
  isDemoUser: boolean
  isLeadUser: boolean
  userRoles: string[]
  companyId: number | undefined
  company: Company | undefined
  defaultResultId: number | undefined
  error: Error | undefined
  loading: boolean
  setUser: (user: User | undefined) => void
  setIsAdmin: (isAdmin: boolean) => void
  setIsDashboardUser: (isDashboardUser: boolean) => void
  setIsDemoUser: (isDemoUser: boolean) => void
  setIsLeadUser: (isLeadUser: boolean) => void
  setUserRoles: (roles: string[]) => void
  setCompanyId: (companyId: number | undefined) => void
  setCompany: (company: Company | undefined) => void
  setDefaultResultId: (defaultResultId: number | undefined) => void
  setError: (error: Error | undefined) => void
  setLoading: (loading: boolean) => void
}

const defaultUserState: UserState = {
  user: undefined,
  isAdmin: false,
  isDashboardUser: false,
  isDemoUser: false,
  isLeadUser: false,
  userRoles: [],
  companyId: undefined,
  company: undefined,
  defaultResultId: undefined,
  error: undefined,
  loading: true,
  setUser: () => {},
  setIsAdmin: () => {},
  setIsDashboardUser: () => {},
  setIsDemoUser: () => {},
  setIsLeadUser: () => {},
  setUserRoles: () => {},
  setCompanyId: () => {},
  setCompany: () => {},
  setDefaultResultId: () => {},
  setError: () => {},
  setLoading: () => {},
}

export const useUserStore = create<UserState>((set) => ({
  ...defaultUserState,
  setUser: (user: User | undefined) => set((state) => ({ ...state, user })),
  setIsAdmin: (isAdmin: boolean) => set((state) => ({ ...state, isAdmin })),
  setIsDashboardUser: (isDashboardUser: boolean) => set((state) => ({ ...state, isDashboardUser })),
  setIsDemoUser: (isDemoUser: boolean) => set((state) => ({ ...state, isDemoUser })),
  setIsLeadUser: (isLeadUser: boolean) => set((state) => ({ ...state, isLeadUser })),
  setUserRoles: (roles: string[]) => set((state) => ({ ...state, userRoles: roles })),
  setCompanyId: (companyId: number | undefined) => set((state) => ({ ...state, companyId })),
  setCompany: (company: Company | undefined) => set((state) => ({ ...state, company })),
  setDefaultResultId: (defaultResultId: number | undefined) => set((state) => ({ ...state, defaultResultId })),
  setError: (error: Error | undefined) => set((state) => ({ ...state, error })),
  setLoading: (loading: boolean) => set((state) => ({ ...state, loading })),
}))
